import moment from 'moment'

export const fromNow = (ts) => {
  return moment.unix(ts).locale('ja').fromNow()
}

export const formatDate = (ts, format) => {
  return moment.unix(ts).format(format)
}
